import { render, staticRenderFns } from "./Masterclasses.vue?vue&type=template&id=74fde4ad&scoped=true&"
import script from "./Masterclasses.vue?vue&type=script&lang=js&"
export * from "./Masterclasses.vue?vue&type=script&lang=js&"
import style0 from "./Masterclasses.vue?vue&type=style&index=0&id=74fde4ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fde4ad",
  null
  
)

export default component.exports